/* CLNR landing page: timecode, filmstrip loop, scroll reveal, sticky mobile bar,
   and service buttons that pre-select the matching option in the form. */
(function () {
  document.documentElement.classList.add('lp-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  var tcs = [].slice.call(document.querySelectorAll('.lp-tcode'));
  if (tcs.length) {
    if (reduce) {
      tcs.forEach(function (e) { e.textContent = '00:00:04:12'; });
    } else {
      var start = performance.now();
      (function tick(now) {
        var s = (now - start) / 1000, f = Math.floor((s % 1) * 24), t = Math.floor(s);
        var txt = pad(Math.floor(t / 3600) % 24) + ':' + pad(Math.floor(t / 60) % 60) + ':' + pad(t % 60) + ':' + pad(f);
        tcs.forEach(function (e) { e.textContent = txt; });
        requestAnimationFrame(tick);
      })(start);
    }
  }

  var track = document.querySelector('.lp-track');
  if (track) track.innerHTML += track.innerHTML;

  var reveals = document.querySelectorAll('.lp-rv');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('lp-on'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    [].forEach.call(reveals, function (el) { io.observe(el); });
  } else {
    [].forEach.call(reveals, function (el) { el.classList.add('lp-on'); });
  }

  var bar = document.getElementById('lp-bar'), hero = document.querySelector('.lp-hero'), ask = document.querySelector('.lp-ask');
  if (bar && hero && ask) {
    var onScroll = function () {
      var past = window.scrollY > hero.offsetHeight - 200;
      var atForm = ask.getBoundingClientRect().top < window.innerHeight * 0.6;
      bar.classList.toggle('lp-on', past && !atForm);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  [].forEach.call(document.querySelectorAll('[data-need]'), function (a) {
    a.addEventListener('click', function () {
      var radios = document.querySelectorAll('input[name="contact[Service]"]');
      [].forEach.call(radios, function (r) { if (r.value === a.getAttribute('data-need')) r.checked = true; });
    });
  });
})();
